import settings from '@/settings'

let propostasApetrus = (headers, data) => {
    let url = `${settings.apetrusApi}/proposta/apetrus/`
    if (data.filtro) {
        const keys = Object.keys(data.filtro)
        for (let i = 0; i < keys.length; i++) {
            url = `${url}${url[url.length - 1] !== '/' ? '&' : '?'}${keys[i]}=${data.filtro[keys[i]]}`
        }
    }
    let request = {
        method: data.method,
        mode: 'cors',
        headers: headers
    }
    if (data.method === 'GET') request.cache = 'default'
    else request.body = JSON.stringify(data)
    return fetch(url, request)
}

export default {
    propostasApetrus
}
